import * as Yup from 'yup'
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

export const editUserSchema = Yup.object({
    name: Yup.string().min(3, 'Length of Name must be between 3 and 30 letters').max(30, 'Length of Name must be between 3 and 30 letters').required('Required'),
    contact: Yup.string().matches(phoneRegExp, 'Phone No. is not Valid'),
    paypal: Yup.string().required('Required')
})
export const changePasswordSchema = Yup.object({
    password: Yup.string().required('Required'),
    confirmPassword: Yup.string().oneOf([Yup.ref("password"), null], 'Password Does Not Match').required('Required'),
})